
class AirplaneFlightPrimary extends HTMLElement {
  static get observedAttributes() {
    return ['color', 'filled', 'label', 'size'];
  }

  constructor() {
    super();
    const shadow = this.attachShadow({ mode: "open" });

    const div = document.createElement('div');
    div.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" class="fil-illu fil-illu__primary" viewBox="0 0 64 64"><g class="fil-illu__primary"><path fill="#c7eaf7" d="M56,23.075v-1a9,9,0,0,0-9-9H46a5,5,0,0,0-7-7,12.405,12.405,0,0,0-10-5,12,12,0,0,0-12,12V30.446H56Z"/><path fill="#00a6e3" d="M19,36.075H7l-3-13H7l5,5H55c4,0,8,3,8,3v2s-4,3-8,3H19Z"/><polygon fill="#016fad" points="43 28.075 27 28.075 17 18.075 25 18.075 43 28.075"/><polygon fill="#016fad" points="43 32.075 27 32.075 17 42.075 25 42.075 43 32.075"/><path fill="#c7eaf7" d="M6,63.075h4L38.075,63a1.962,1.962,0,0,0,1.962-1.963A1.962,1.962,0,0,1,42,59.075H56a7,7,0,1,0-3.914-12.8L52,46.276a13.956,13.956,0,0,0-10-4.2c-5.971,0-8.92,3-10,6a36.048,36.048,0,0,0-1.551,3.685h0A9.016,9.016,0,0,0,21,53.366v-.291c0-2-3-5-7-5s-7,2-8,5a5,5,0,0,0,0,10"/></g><g fill="none" stroke="#414956" stroke-width="2" class="fil-illu__lines"><path d="M19,36.075H7l-3-13H7l5,5H55c4,0,8,3,8,3v2s-4,3-8,3H42"/><polygon points="43 28.075 27 28.075 17 18.075 25 18.075 43 28.075"/><polygon points="43 32.075 27 32.075 17 42.075 25 42.075 43 32.075"/><line x1="52" x2="50" y1="32.075" y2="32.075"/><line x1="48" x2="46" y1="32.075" y2="32.075"/><line x1="22" x2="20" y1="32.075" y2="32.075"/><line x1="18" x2="16" y1="32.075" y2="32.075"/><line x1="14" x2="12" y1="32.075" y2="32.075"/><line x1="14" x2="6" y1="42.075" y2="42.075"/><line x1="4" y1="42.075" y2="42.075"/><line x1="14" x2="10" y1="18.075" y2="18.075"/><line x1="8" y1="18.075" y2="18.075"/><path d="M56 23.075v-1a9 9 0 0 0-9-9H46a5 5 0 0 0-7-7 12.405 12.405 0 0 0-10-5 12 12 0 0 0-12 12M32 48.075c1.08-3 4.029-6 10-6a13.956 13.956 0 0 1 10 4.2M18 60.075a9 9 0 0 1 15-6.707"/><path d="M49,52.075a7,7,0,1,1,7,7"/><line x1="56" x2="42" y1="59.075" y2="59.075"/><line x1="40" x2="36" y1="59.075" y2="59.075"/><line x1="6" x2="10" y1="63.075" y2="63.075"/><path d="M21,53.075c0-2-3-5-7-5s-7,2-8,5a5,5,0,0,0,0,10"/></g></svg>';
    this.svg = div.getElementsByTagName('svg')[0];
    this.svg.setAttribute('role', 'img');
    this.svg.setAttribute('aria-label', this.label?this.label:`AirplaneFlightPrimary`);

    const style = document.createElement("style");
    style.textContent = `:host{
    display: inline-block;
    vertical-align: middle;
  }
  .fil-illu[data-size="128"] {
    width: 128px;
    height: 128px;
    stroke-width: 3px;
  }
  .fil-illu[data-size="256"] {
    width: 256px;
    height: 256px;
    stroke-width: 4px;
  }`;

    shadow.appendChild(style);
    shadow.appendChild(this.svg);
  }

  setProperty(prop, value) {
    if (value !== null) {
      this.setAttribute(`${prop}`, value);
      this.svg.setAttribute(`data-${prop}`, value);
    } else {
      this.removeAttribute(`${prop}`);
      this.svg.removeAttribute(`data-${prop}`);
    }
  }

  get color() {
    return this.getAttribute('color');
  }

  set color(color) {
    this.setProperty('color', color);
  }

  get filled() {
    return this.getAttribute('filled');
  }

  set filled(filled) {
    this.setProperty('filled', filled);
  }

  get label() {
    return this.getAttribute('size');
  }

  set label(label) {
    if (label !== null) {
      this.svg.setAttribute('aria-label', label);
      this.svg.setAttribute('title', label);
      this.svg.setAttribute('aria-hidden', 'false');
    } else {
      this.svg.removeAttribute('aria-label');
      this.svg.setAttribute('title', `AirplaneFlightPrimary`);
      this.svg.setAttribute('aria-hidden', 'true');
    }
  }

  get size() {
    return this.getAttribute('size');
  }

  set size(size) {
    this.setProperty('size', size);
  }

  attributeChangedCallback(prop, oldV, newV) {
    if (oldV !== newV) {
      this[`${prop}`] = newV;
    }
  }
}

customElements.define('fil-pictogram-airplane-flight-primary', AirplaneFlightPrimary);
